import React from 'react'
import { Button, Dialog, TextField, Typography, useMediaQuery } from '@mui/material'
import { Link } from 'react-router-dom'
import SearchRoundedIcon from '@mui/icons-material/SearchRounded'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded'
import useStyles from './_styles'
import useButtonStyles from '../../../styles/buttonsStyles'
import useFormStyles from '../../../styles/formsStyles'
import PageContentHeader from '../../Common/pageContent/PageContentHeader'
import { PlannedExpertiseHeaderProps } from './_props'
import { defaultPalette } from '../../../theme/idsTheme'
import { PersonRoundedIcon } from '../../../assets/icons/icons'

const PlannedExpertiseHeader = ({
    setSearch,
    search,
    isPreview,
    previewTitle,
    renderLeftHeader,
    disabled,
}: PlannedExpertiseHeaderProps) => {
    const classes = useStyles()
    const buttons = useButtonStyles()
    const forms = useFormStyles()
    const [isSearchDialogOpen, setIsSearchDialogOpen] = React.useState(false)

    const isLargeScreen = useMediaQuery('(min-width:1000px)')

    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value)
    }

    const handleToggleSearchDialog = () => {
        setIsSearchDialogOpen(!isSearchDialogOpen)
    }

    const renderPatientSearchField = () => (
        <TextField
            defaultValue={search}
            onInput={handleOnChange}
            label={
                <Typography className={forms.SearchFieldLabel}>
                    <SearchRoundedIcon />
                    <span>Recherche par patient ou par requis</span>
                </Typography>
            }
            className={forms.SearchField}
            id="outlined-basic"
            variant="outlined"
            disabled={disabled}
            sx={{
                opacity: !disabled ? 1 : 0.54,
                '& .endAdornmentLocked': {
                    '> svg': {
                        opacity: 1,
                        color: `${defaultPalette.typography.main}`,
                    },
                },
            }}
        />
    )

    const renderPatientSearchDialog = () => (
        <>
            <Button
                onClick={handleToggleSearchDialog}
                className={buttons.ButtonBlack}
                disableElevation
                variant="contained"
                disabled={disabled}
            >
                <SearchRoundedIcon />
            </Button>
            <Dialog
                open={isSearchDialogOpen}
                onClose={handleToggleSearchDialog}
                classes={{
                    paper: classes.PlannedExpertiseHeaderSearchDialogPaper,
                }}
            >
                <Typography>Recherche par patient ou par requis</Typography>
                {renderPatientSearchField()}
            </Dialog>
        </>
    )

    const renderSearch = !isPreview && renderLeftHeader

    if (isPreview) {
      return (
        <div className={classes.PlannedExpertiseHeader}>
          <div className={classes.PlannedExpertiseHeaderContent}>
          <PageContentHeader
          left={
                  <>
                      {isPreview && previewTitle}
                      {renderSearch && (isLargeScreen ? renderPatientSearchField() : renderPatientSearchDialog())}
                  </>
              }
              right={
                <Button
                to="/teleexpertise"
                component={Link}
                startIcon={<AddCircleRoundedIcon />}
                className={buttons.ButtonBlack}
                disableElevation
                variant="contained"
                disabled={disabled}
                >
                      Nouvelle téléexpertise
                  </Button>
              }
              />
          </div>
        </div>
      )
    }

    return (
      <div className={classes.PlannedExpertiseHeaderWrapper}>
        <div className={classes.PlannedExpertiseHeaderButtonsContainer}>
          <PageContentHeader
          left={
                  <>
                  <div className={classes.PlannedExpertiseHeaderLeft}>
                            {renderSearch && (isLargeScreen ? renderPatientSearchField() : renderPatientSearchDialog())}
                      </div>
                  </>
              }
              right={
                <>
                  <Button
                      to="/requesters"
                      component={Link}
                      startIcon={<PersonRoundedIcon />}
                      className={buttons.ButtonWhite}
                      disableElevation
                      variant="contained"
                      disabled={disabled}
                  >
                      Gérer les requérants
                  </Button>
                  <Button
                      to="/teleexpertise/"
                      component={Link}
                      startIcon={<AddCircleRoundedIcon />}
                      className={buttons.ButtonBlack}
                      disableElevation
                      variant="contained"
                      disabled={disabled}
                  >
                      Nouvelle téléexpertise
                  </Button>
                  </>
              }
          />
          </div>
        </div>
    )
}

export default PlannedExpertiseHeader

